module.exports = __webpack_public_path__ + "assets/524271b32393f599be5e32eda6e88964.png";